// extracted by mini-css-extract-plugin
module.exports = {"PasswordResetEmail":"yl_a bha_px bha_a bha_w bha_cw bha_sb","PasswordResetEmail__title":"yl_b bha_uj bha_qk bha_tu","PasswordResetEmail__subtitle":"yl_c bha_tu"};